import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/formCategory/importer/formCategoryImporterSelectors';
import FormCategoryService from 'src/modules/formCategory/formCategoryService';
import fields from 'src/modules/formCategory/importer/formCategoryImporterFields';
import { i18n } from 'src/i18n';

const formCategoryImporterActions = importerActions(
  'FORMCATEGORY_IMPORTER',
  selectors,
  FormCategoryService.import,
  fields,
  i18n('entities.formCategory.importer.fileName'),
);

export default formCategoryImporterActions;